import { render } from "./WhyChooseUs.vue?vue&type=template&id=5b3a2806&scoped=true"
import script from "./WhyChooseUs.vue?vue&type=script&lang=js"
export * from "./WhyChooseUs.vue?vue&type=script&lang=js"

import "./WhyChooseUs.vue?vue&type=style&index=0&id=5b3a2806&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b3a2806"]])

export default __exports__